<template>
  <div class="page-list">
    <div class="input-box down-caret">
      <select v-model="page" class="page-list-select" @change="selected()" ref="pageSelector">
        <option disabled value>Please select a page</option>
        <option v-for="(item,key) in dataPages" :key="key" :value="item">{{item.data.name}}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dataPages"],
  data() {
    return {
      page: ""
    };
  },
  methods: {
    selected: function() {
      return this.$emit("page-data", this.page);
    },
    changeColor: function() {
      this.$refs.pageSelector.style.setProperty("--inputColor", "black");
    }
  }
};
</script>





// WEBPACK FOOTER //
// pageList.vue?5bd4232f